<template>

  <text-field-with-placeholder
    id="document-tax-id-field"
    v-model="form.taxID"
    :validation="$v.taxID"
    :validationMessage="textRequired"
    :placeholder="placeholder"
    :label="textTitle"
    :rest="{
      'format': placeholder,
    }"
    class="input-container variant-1"
    theme="variant-1"
    :tabindex="tabindex"
    :order="order"
    @input="input" />

</template>


<script>

  import  { applyMaskForInput } from '../../../utils/checkout';


  export default {

    name: 'TaxId',

    props: [
      'extraFields',
      'tabindex',
      'order',
      'form',
      '$v',
    ],

    data() {
      return {
        mask: 'Pxxxxxxxxxxxx'
      }
    },


    computed: {

      textTitle() {
        return this.$t('document_type.co.nit');
      },

      textRequired() {
        return this.$t('checkout.payment_form.document_number.required');
      },

      placeholder() {
        return 'P............';
      },

    },


    methods: {

      input() {
        this.form.taxID = applyMaskForInput(
          this.form.taxID,
          this.mask,
          [...Array(12).keys()].map(i => '\\d')
        );
      },

    },

  };

</script>


<style lang="scss">

</style>
